import React from 'react';
import { FicheContainer, useFiche } from '@mairistem/fiche';
import { ErrorField } from '@mairistem/liste';
import { controleSaisie } from './TiersFicheControlesMetier';
import TiersFicheConsumer from './TiersFicheConsumer';
import '../Tiers.less';
import TiersFicheBarConsumer, { handleCreatingFicheTiers } from './TiersFicheBarConsumer';

const handleUrl = (method: string, { identifiant }) => {
  const params = 'withContacts=true&withRibs=true&withAdresses=true';

  switch (method) {
    case 'get':
      return `/api/finances/comptabilite/tiers/${identifiant}?${params}`;
    case 'put':
      return `/api/finances/comptabilite/tiers/${identifiant}?${params}&isBanqueMandatory=true`;
    case 'delete':
      return `/api/finances/comptabilite/tiers/${identifiant}`;
    default:
      return '/api/finances/comptabilite/tiers?isBanqueMandatory=true';
  }
};

const TiersFiche = () => {
  const [tiersService] = useFiche(handleUrl);
  const [isModalSemaphoreVisible, setIsModalSemaphoreVisible] = React.useState(false);

  const handleApiError = (errors): ErrorField[] => {
    if (errors?.status >= 500) {
      return [
        {
          id: null,
          message: 'Une erreur technique est survenue',
        },
      ];
    }
    const responseErrors = errors?.response?.data;

    // Si l'une des erreurs a le code 'semaphore', afficher la modale
    if (responseErrors.some((err) => err?.code === 'semaphore')) {
      setIsModalSemaphoreVisible(true);
    }

    const resultErrors = responseErrors.map((error) => ({
      id: error?.id || null,
      message: error?.message,
    }));

    return resultErrors;
  };

  return (
    <FicheContainer
      onValidate={controleSaisie}
      onApiError={handleApiError}
      type="tiers"
      hasHistory={false}
      service={tiersService}
      onCreating={handleCreatingFicheTiers}
    >
      {({
        identifiant, ...handlers
      }) => (
        <>
          <TiersFicheBarConsumer identifiant={identifiant} {...handlers} />
          <TiersFicheConsumer
            {...handlers}
            handleChangeModalSemaphoreVisible={setIsModalSemaphoreVisible}
            isModalSemaphoreVisible={isModalSemaphoreVisible}
          />
        </>
      )}

    </FicheContainer>
  );
};

export default TiersFiche;
